import * as React from 'react'

import { FirstName, FormGroup, LastName } from '@grandvisionhq/forms'
import { useIntl } from '@grandvisionhq/state'

import { isName } from '../../../validators'

const NameField: React.FC = () => {
  const { getLabel } = useIntl()

  return (
    <FormGroup columns={2}>
      <FirstName
        label={getLabel('checkout.contact.firstName')}
        errorMessage={getLabel('checkout.contact.firstName.errorMessage')}
        validations={[isName]}
      />
      <LastName
        label={getLabel('checkout.contact.lastName')}
        errorMessage={getLabel('checkout.contact.lastName.errorMessage')}
        validations={[isName]}
      />
    </FormGroup>
  )
}

export default NameField
